module.exports = __webpack_public_path__ + "static/3d-storage-logo-189ac1f51cbefbe622b0ac1fe1327b54.png";